import * as React from "react";
import { forwardRef, memo } from "react";
const SvgEdit = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icon/edit" }, /* @__PURE__ */ React.createElement("path", { id: "ic", d: "M3.2071 7.94501L8.27815 2.87393L7.57105 2.16682L2.5 7.23791V7.94501H3.2071ZM3.62132 8.94501H1.5V6.82366L7.2175 1.10616C7.4128 0.910902 7.72935 0.910902 7.9246 1.10616L9.33885 2.52038C9.5341 2.71564 9.5341 3.03222 9.33885 3.22748L3.62132 8.94501ZM1.5 9.94501H10.5V10.945H1.5V9.94501Z", fill: "#2F2F2F" })));
const ForwardRef = forwardRef(SvgEdit);
const Memo = memo(ForwardRef);
export default Memo;
